<!--
Author: TangChen
Date: 2019-10-23
Desc: 开户成功结果页
 -->
<template>
    <div :class="'view-open-success view bg-white ' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <div class="success">
            <result :result="resultObj" v-on:login-now="logout" v-on:return-login="login" />
        </div>
        <!--内容-->
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import navBar from "@/components/common/navBar.vue";
import result from "@/components/common/result.vue";
export default {
    name: "ViewOpenSuccess",
    components: {
        navBar,
        result
    },
    mixins: [mixin],
    data () {
        return {
            navs: [
                {id: "1",val: "经办人信息"},
                {id: "2",val: "基本信息"},
                {id: "3",val: "信息登记"},
                {id: "4",val: "银行信息"},
                {id: "5",val: "文件上传"},
                {id: "6",val: "完成注册",icon: "fa fa-check",active: "1"}
            ],
            resultObj: {// 结果页面信息
                cla: "register-success",
                msg: "恭喜您，已开户成功！",
                btnMsg: "工作人员将在1-3个工作日内为您审核，请耐心等待！",
                warning: [
                    "1、机构开户的用户，若投资者分类未选择“法人或其他组织”请及时登录系统做知识评测，以免影响审核进度 。",
                    "2、产品开户的用户，请及时登录系统做知识评测，以免影响审核进度。"],
                btnL: {
                    text: "返回登录",
                    event: "login-now"
                },
                btnR: {
                    text: "进入首页",
                    event: "return-login"
                }
            }
        };
    },
    mounted() {
    },
    methods: {
        login(){
            const _this = this;
            this.$util.request("orgopen/setlogin",{},"POST").then(res=>{
                if(res.data){
                    const x = {
                        token: _this.$cache.getSessionToken(),
                        key: _this.$cache.getSessionKey()
                    };
                    _this.$store.dispatch("login", res.data[0] || x).then(() => {
                        _this.$router.replace({name: "home"});
                    });
                }else{
                    _this.$router.replace({name: "login"});
                }
            });
        },
        logout(){
            const _this = this;
            if(!this.$store.state.login.status){
                this.$router.push({name: "login"});
                return;
            }
            this.$util.request("common/logout", {}, false, false).then(res => {
                if (res.data) {
                    _this.$store.dispatch("logout", res.data[0]).then(() => {
                        _this.$router.replace({name: "login"});
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
    .view-open-success {
        margin-top: 5px;
        padding: 10px 55px;
        .success{
            padding: 15px 0 100px;
        }
        /*颜色，背景写在css/theme.scss内views style下*/
    }
</style>
